import { Link } from 'react-router-dom';
import { navLinks } from '@/mocks/navigation';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="py-14 md:py-16">
          <div className="flex flex-col lg:flex-row gap-10 lg:gap-20">
            <div className="lg:w-80">
              <div className="flex items-center gap-2 mb-4">
                <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500 text-background-50 text-sm font-bold font-heading">
                  草
                </span>
                <span className="text-xl font-heading font-semibold text-background-50">
                  草灯和尚
                </span>
              </div>
              <p className="text-secondary-300 text-sm leading-relaxed">
                以草为灯，以心照路。草灯和尚是承载禅宗智慧与草木灵性的文化符号，
                致力于传播东方生活美学与心灵修行之道。
              </p>
            </div>

            <div className="flex-1 grid grid-cols-2 md:grid-cols-3 gap-8">
              <div>
                <h4 className="text-sm font-semibold text-background-50 mb-4">探索内容</h4>
                <ul className="space-y-2.5">
                  {navLinks.filter(l => l.href !== '/' && l.href !== '/about').map((link) => (
                    <li key={link.href}>
                      <Link
                        to={link.href}
                        className="text-sm text-secondary-300 hover:text-background-50 transition-colors"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <h4 className="text-sm font-semibold text-background-50 mb-4">关于我们</h4>
                <ul className="space-y-2.5">
                  <li>
                    <Link to="/about" className="text-sm text-secondary-300 hover:text-background-50 transition-colors">
                      品牌介绍
                    </Link>
                  </li>
                  <li>
                    <Link to="/about" className="text-sm text-secondary-300 hover:text-background-50 transition-colors">
                      口碑声誉
                    </Link>
                  </li>
                  <li>
                    <Link to="/about" className="text-sm text-secondary-300 hover:text-background-50 transition-colors">
                      联系我们
                    </Link>
                  </li>
                </ul>
              </div>
              <div>
                <h4 className="text-sm font-semibold text-background-50 mb-4">关注我们</h4>
                <div className="flex gap-3">
                  <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-secondary-300 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="微信" rel="nofollow">
                    <i className="ri-wechat-line text-base"></i>
                  </a>
                  <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-secondary-300 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="微博" rel="nofollow">
                    <i className="ri-weibo-line text-base"></i>
                  </a>
                  <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-secondary-300 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="公众号" rel="nofollow">
                    <i className="ri-qr-code-line text-base"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-secondary-400">
            &copy; {currentYear} 草灯和尚文化研究院. 保留所有权利.
          </p>
          <div className="flex gap-4">
            <a href="#" className="text-xs text-secondary-400 hover:text-background-50 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-secondary-400 hover:text-background-50 transition-colors">使用条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}